import {Modal} from "react-bootstrap";

import NewTab from './Icons/NewTab';
import UserDataDisplay from "./UserDataDisplay";
import EmployeeInfo from "../types/Employee/EmployeeInfo";

type UserInfoModalProps = {
    userData: EmployeeInfo,
    targetUserData: EmployeeInfo,
    showModal: boolean,
    closeInfoModal: () => void;
}

const UserInfoModal = ({ userData, targetUserData, showModal, closeInfoModal }: UserInfoModalProps) => (
    <Modal
        className='modal-lg'
        show={showModal}
        onHide={() => closeInfoModal()}
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title className='user-data-modal-header'>
                <h3 className='ps-4 mt-2'>
                    {
                        userData.employeeID !== targetUserData.employeeID &&
                        <>{userData.firstName}&nbsp;{userData.lastName}&nbsp;As&nbsp;</>
                    }
                    {targetUserData.firstName}&nbsp;{targetUserData.lastName}&nbsp;
                    <a
                        href='/userinfo'
                        target='_blank'
                        onClick={() => closeInfoModal()}
                        title={`open ${targetUserData.firstName} ${targetUserData.lastName} info in a new tab`}
                    >
                        <NewTab />
                    </a>
                </h3>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div
              className='mb-4'
            >
                <UserDataDisplay userData={targetUserData} asModal={true}/>
            </div>
        </Modal.Body>
    </Modal>
);

export default UserInfoModal;